// Shared pricing for identity add-on bundles.
// Eligible users pay the full price up to the cap and the discounted price for
// units beyond it; everyone else (or when no discounted price is available) pays
// the full price for every unit.
export function blendedAddonPrice({ units, fullPrice, discountedPrice, discountEligible, fullPriceCapUnits }) {
  if (!discountEligible || isNaN(discountedPrice)) {
    return units * fullPrice;
  }

  const fullUnits = Math.min(units, fullPriceCapUnits);
  const discountedUnits = Math.max(units - fullPriceCapUnits, 0);
  return (fullUnits * fullPrice) + (discountedUnits * discountedPrice);
}
